import * as React from "react";

import CostForm from "../../../components/Forms/ParkingContract/CostForm/FlowForm";

export default function ParkingContractCostForm() {
  return <CostForm />;
}
